/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * API request serializer for token validation endpoints.
 * Used for OpenAPI schema generation.
 * @export
 * @interface APIAPITokenRequestRequest
 */
export interface APIAPITokenRequestRequest {
    /**
     * The verification token
     * @type {string}
     * @memberof APIAPITokenRequestRequest
     */
    token: string;
}

/**
 * Check if a given object implements the APIAPITokenRequestRequest interface.
 */
export function instanceOfAPIAPITokenRequestRequest(value: object): value is APIAPITokenRequestRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function APIAPITokenRequestRequestFromJSON(json: any): APIAPITokenRequestRequest {
    return APIAPITokenRequestRequestFromJSONTyped(json, false);
}

export function APIAPITokenRequestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIAPITokenRequestRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function APIAPITokenRequestRequestToJSON(value?: APIAPITokenRequestRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'token': value['token'],
    };
}

